import { Injectable } from '@angular/core';
import { STUDY_KPI_KEYS_TO_STAGES_MAPPING } from '@catalogues';
import { KpiCategories, KpiKeys, KpisByCategory, KpisByKey, StageName } from '@models';

@Injectable({
  providedIn: 'root'
})
export class KpiFilterService {
  filterKpisByStage(stages: StageName[], kpisByCategory: KpisByCategory): KpisByCategory {
    const kpisByCategoryArray = Object.entries(kpisByCategory) as [KpiCategories, KpisByKey][];

    return kpisByCategoryArray.reduce((currentFilteredKpis, [category, kpis]) => {
      const filteredCategoryKpis = this.getFilteredCategoryKpis(kpis, stages);

      if (Object.keys(filteredCategoryKpis).length) {
        currentFilteredKpis[category] = filteredCategoryKpis;
      }

      return currentFilteredKpis;
    }, {} as KpisByCategory);
  }

  private kpiIsInStages(stages: StageName[], kpiKey: KpiKeys): boolean {
    if (!STUDY_KPI_KEYS_TO_STAGES_MAPPING[kpiKey]) return false;

    return STUDY_KPI_KEYS_TO_STAGES_MAPPING[kpiKey].some((kpiStage) => stages.includes(kpiStage));
  }

  private getFilteredCategoryKpis(kpis: KpisByKey, stages: StageName[]): KpisByKey {
    const filteredCategoryKpis = Object.entries(kpis).filter(([kpiKey]) =>
      this.kpiIsInStages(stages, kpiKey as KpiKeys)
    );
    return Object.fromEntries(filteredCategoryKpis) as KpisByKey;
  }
}
